// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1HoDu","requiredAsterisk":"Info_requiredAsterisk__IEOw2"};